import type {
  RecallProgramTemplateCreateApiData,
  RecallProgramTemplateCreateApiResponses,
  RecallProgramTemplateDeleteApiData,
  RecallProgramTemplateDeleteApiResponses,
  RecallProgramTemplateGetApiData,
  RecallProgramTemplateGetApiResponses,
  RecallProgramTemplateListApiData,
  RecallProgramTemplateListApiResponses,
  RecallProgramTemplatePatchApiData,
  RecallProgramTemplatePatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getRecallProgramTemplateUrls = {
  getRecallProgramTemplates: dataEndpoint<RecallProgramTemplateListApiData, RecallProgramTemplateListApiResponses>({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/recall-program-templates/`, queryParams)
  }),
  getRecallProgramTemplate: dataEndpoint<RecallProgramTemplateGetApiData, RecallProgramTemplateGetApiResponses>({
    getUrl: ({ serviceDepartmentId, recallProgramTemplateId }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/recall-program-templates/${recallProgramTemplateId}/`)
  }),
  postRecallProgramTemplate: responseEndpoint<
    RecallProgramTemplateCreateApiData,
    RecallProgramTemplateCreateApiResponses
  >({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/recall-program-templates/`),
    getBody: ({ serviceDepartmentId: _, ...body }) => body
  }),
  patchRecallProgramTemplate: responseEndpoint<
    RecallProgramTemplatePatchApiData,
    RecallProgramTemplatePatchApiResponses
  >({
    getUrl: ({ serviceDepartmentId, recallProgramTemplateId }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/recall-program-templates/${recallProgramTemplateId}/`),
    getBody: ({ serviceDepartmentId: _, recallProgramTemplateId: _id, ...body }) => body
  }),
  deleteRecallProgramTemplate: dataEndpoint<
    RecallProgramTemplateDeleteApiData,
    RecallProgramTemplateDeleteApiResponses
  >({
    getUrl: ({ serviceDepartmentId, recallProgramTemplateId }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/recall-program-templates/${recallProgramTemplateId}/`)
  })
};
